import React from 'react';
import { Icon } from './Icon.jsx';

/**
 * Tabs — pill-style segmented navigation. Controlled (`value`+`onChange`) or
 * uncontrolled (`defaultValue`). Items: [{ value, label, icon }].
 */
export function Tabs({ items = [], value, defaultValue, onChange, style, ...rest }) {
  const [internal, setInternal] = React.useState(defaultValue ?? items[0]?.value);
  const active = value !== undefined ? value : internal;
  const select = (v) => { if (value === undefined) setInternal(v); onChange?.(v); };

  return (
    <div role="tablist" style={{
      display: 'inline-flex', gap: 4, padding: 4,
      background: 'var(--surface-sunken)', borderRadius: 'var(--radius-pill)',
      ...style,
    }} {...rest}>
      {items.map((it) => {
        const on = it.value === active;
        return (
          <button key={it.value} role="tab" aria-selected={on} type="button"
            onClick={() => select(it.value)}
            style={{
              display: 'inline-flex', alignItems: 'center', gap: 7,
              border: 'none', cursor: 'pointer',
              background: on ? 'var(--surface-card)' : 'transparent',
              color: on ? 'var(--text-strong)' : 'var(--text-muted)',
              boxShadow: on ? 'var(--shadow-xs)' : 'none',
              fontFamily: 'var(--font-sans)', fontWeight: 'var(--fw-semibold)', fontSize: 'var(--text-sm)',
              padding: '8px 16px', borderRadius: 'var(--radius-pill)',
              transition: 'background var(--dur-fast) var(--ease-out), color var(--dur-fast) var(--ease-out)',
            }}>
            {it.icon && <Icon name={it.icon} size={16} />}
            {it.label}
          </button>
        );
      })}
    </div>
  );
}
